import { PanelType, SelectionMode } from '@fluentui/react';
import React, { useEffect, useRef, useState } from 'react';
import { EmptyColumn } from '../defaults';
import { paginateDataAsync } from '../utilities';
import { Guid } from '../utilities/Guid';
import { DataTable } from './DataTable';
import { StandarDataTableItem } from './StandarDataTableItem';
export const StandarDataTable = function (props) {
    const dtRef = useRef();
    const [key, setKey] = useState('');
    const [commandBarItems, setCommandBarItems] = useState();
    const [selection, setSelection] = useState({});
    useEffect(() => {
        const proxy = new Proxy({}, { get: (target, property) => setKey(property) });
        props.rowKey(proxy);
        buildCommandBar();
    }, []);
    useEffect(() => {
        dtRef.current.refreshTable();
    }, [JSON.stringify(props.items)]);
    const buildCommandBar = (selectedItems) => {
        const createId = () => {
            let guid = Guid.newGuid().toString();
            while (props.items.find(o => o[key] === guid) != null)
                guid = Guid.newGuid().toString();
            return guid;
        };
        const items = [];
        if (props.readonly) {
            if (selectedItems != null) {
                items.push({
                    key: 'view',
                    name: 'Ver',
                    iconProps: { iconName: 'View' },
                    onClick: () => setSelection({ item: Object.assign({}, selectedItems[0]) })
                });
            }
        }
        else {
            items.push({
                key: 'add',
                name: 'Agregar',
                iconProps: { iconName: 'Add' },
                onClick: () => {
                    const item = { [key]: createId() };
                    setSelection({ item });
                }
            });
            if ((selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length) === 1) {
                items.push({
                    key: 'edit',
                    name: 'Editar',
                    iconProps: { iconName: 'Edit' },
                    onClick: () => setSelection({ item: Object.assign({}, selectedItems[0]) })
                });
                items.push({
                    key: 'Eliminar',
                    name: 'Eliminar',
                    iconProps: { iconName: 'Delete' },
                    onClick: () => {
                        const items = [...props.items];
                        const index = items.findIndex(o => o[key] === selectedItems[key]);
                        items.splice(index, 1);
                        props.onItemsChanged(items);
                    }
                });
            }
        }
        setCommandBarItems(items);
    };
    return React.createElement(React.Fragment, null,
        React.createElement(DataTable, { onSelectedRow: (items) => buildCommandBar(items), selectionMode: SelectionMode.single, columns: [
                ...props.columns.map(column => ({
                    key: column.name,
                    name: column.name,
                    fieldName: '',
                    minWidth: column.minWidth,
                    maxWidth: column.maxWidth || column.minWidth + 20,
                    isResizable: typeof column.isResizable === 'boolean' ? column.isResizable : true,
                    onRender: (row) => column.onRender(row)
                })),
                EmptyColumn
            ], title: props.tableTitle, commandBarItems: commandBarItems, ref: dtRef, titleClassName: 'ms-fontSize-l', onDownloadServerData: (request) => {
                return paginateDataAsync(request, {
                    data: () => props.items || [],
                    order: ['Text', 'Icon'],
                    search: () => props.searchColumns || []
                });
            } }),
        selection.item != null && React.createElement(StandarDataTableItem, { value: selection.item, readonly: props.readonly || false, onChanged: item => setSelection(Object.assign(Object.assign({}, selection), { item })), onClose: () => setSelection({ item: null }), onAccept: () => {
                const items = props.items.slice();
                const currentItem = selection.item;
                const index = items.findIndex(o => o[key] === currentItem[key]);
                if (index >= 0) {
                    items[index] = currentItem;
                }
                else {
                    items.push(currentItem);
                }
                props.onItemsChanged(items);
            }, onRender: (errors, setProperty) => {
                if (selection.item != null)
                    return props.onRenderItemPanel(selection.item, errors, setProperty);
                return React.createElement(React.Fragment, null);
            }, title: props.panelTitle, panelType: props.panelType || PanelType.medium, onValidate: props.onValidate }));
};
